<template>
  <time v-bind:datetime="isoFormat">{{ formattedValue }}</time>
</template>

<script>
import Vue from "vue";
import DatetimeUtil from "../plugins/datetime-util";
import {DateTime} from "luxon";

Vue.use(DatetimeUtil);

export default {
  name: "formatted-date",
  props: {
    value: {
      type: Object,
      validator: function (value) {
        return DateTime.isDateTime(value);
      }
    },
    /**
     * Supports Luxon tokens (https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
     */
    format: {
      type: String,
      default: "yyyy-MM-dd"
    },
    /**
     * Values range from 1 to 7 for Mon to Sun. Default 1 is Mon.
     */
    firstWeekday: {
      type: Number,
      default: 1,
      validator: function (value) {
        return value >= 1 && value <= 7;
      }
    },
    locale: {
      type: String,
      default: "en"
    },
  },
  computed: {
    formattedValue: function () {
      return Vue.$datetimeUtil.getAsString(this.value, this.format, this.datetimeUtilOptions);
    },
    isoFormat: function () {
      return Vue.$datetimeUtil.getAsString(this.value, "yyyy-MM-dd HH:mm:ss", this.datetimeUtilOptions);
    },
    datetimeUtilOptions: function () {
      return {
        firstWeekday: this.firstWeekday,
        locale: this.locale
      }
    }
  }
}
</script>
